/* eslint-disable no-use-before-define */

/**
 * Helper constants and functions
 */
// Utility function to use String.replace preventing type errors
function saferReplace(value, pattern, replacement) {
  if (typeof value === 'string') {
    return value.replace(pattern, replacement);
  }
  return value;
}

/**
 * URL functions
 */
function getCanonical(url) {
  let ret = url;
  if (typeof url === 'object') {
    ret = stripTrailingSlash(url.canonical || url.primary || null);
  } else {
    ret = stripTrailingSlash(url);
  }
  if (/http:\/\/[^.]+.(nbcnews|today|msnbc).com\//.test(ret)) {
    return securify(ret);
  }
  return ret;
}

// Basic url validation
function isValidUrl(url) {
  return /^((https?|ftp|smtp):\/\/)?([^\\.]+.)?[a-z0-9]+\.[a-z]+(\/[a-zA-Z0-9#\\-]+\/?)*$/.test(url);
}

// Extract core parts of URL, since URL API is not supported in IE 11
function parseOnClient(url) {
  // Must parse on client-side only
  if (!__CLIENT__) return {}; // eslint-disable-line no-undef

  // Could use a RegExp here but there are an incredible amount of edge cases to cover
  // It's best to let the browser handle this directly
  const a = document.createElement('a');
  a.href = url;
  // Path parts from anchor element
  const {
    hash,
    pathname,
    search,
  } = a;

  // Hostname and protocol from window.location
  const {
    hostname,
    protocol,
    port,
  } = window.location;

  return {
    hash,
    hostname,
    pathname,
    port,
    protocol,
    search,
  };
}

// Replace 'http' with 'https'
function securify(url) {
  return saferReplace(url, 'http:', 'https:');
}

// Convert object into query string of ?{key}={value}
function serialize(obj, encode = true) {
  const str = Object.keys(obj)
    .filter((k) => typeof obj[k] !== 'undefined')
    .reduce((a, k) => {
      a.push(`${k}=${encode ? encodeURIComponent(obj[k]) : obj[k]}`);
      return a;
    }, [])
    .join('&');
  return `?${str}`;
}

// String trailing slash on url
function stripTrailingSlash(url) {
  return saferReplace(url, /\/$/, '');
}

// Strip leading slash on url
function stripLeadingSlash(url) {
  return saferReplace(url, /^\//, '');
}

module.exports = {
  getCanonical,
  isValidUrl,
  parseOnClient,
  securify,
  serialize,
  stripTrailingSlash,
  stripLeadingSlash,
};
